var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"immo-support-enum"},_vm._l((_vm.icons),function(icon){return _c(icon,{key:icon,tag:"component"})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }